import { getRandomString } from '../services/AuthService';
import { getPortalApiConfig } from './EnvironmentVariable';

export const addSearchHistory = async (searchString, resultCount, state) => {
  const { portalApi, portalKey } = getPortalApiConfig();
  // let formData = new FormData();
  // formData.append("searchString", searchString);
  // formData.append("resultCount", resultCount);
  // formData.append("state", state);

  var formBody = [];
  formBody.push(encodeURIComponent('searchString') + '=' + encodeURIComponent(searchString));
  formBody.push(encodeURIComponent('resultCount') + '=' + encodeURIComponent(resultCount));
  formBody.push(encodeURIComponent('state') + '=' + encodeURIComponent(state));
  formBody.push(encodeURIComponent('source') + '=' + encodeURIComponent('LeaderConnect'));
  formBody = formBody.join('&');

  let headers = new Headers();
  const token = sessionStorage.getItem('access_token');
  headers.append('Authorization', 'Bearer ' + token);
  headers.append('client_id', portalKey);
  const message = getRandomString(25);
  headers.append('X-NW-Message-ID', message);
  headers.append('Content-Type', 'application/x-www-form-urlencoded');
  const response = await fetch(portalApi + 'searchhistories', {
    method: 'post',
    headers: headers,
    body: formBody,
  });
  const jsondata = await response.json();
  return jsondata;
};

export const addSearchResultActivity = async (searchHistoryId, activity, description) => {
  const { portalApi, portalKey } = getPortalApiConfig();
  // let formData = new FormData();
  // formData.append("searchHistoryId", searchHistoryId);
  // formData.append("activity", activity);
  // formData.append("description", description);

  var formBody = [];
  formBody.push(encodeURIComponent('searchHistoryId') + '=' + encodeURIComponent(searchHistoryId));
  formBody.push(encodeURIComponent('activity') + '=' + encodeURIComponent(activity));
  formBody.push(encodeURIComponent('description') + '=' + encodeURIComponent(description));
  formBody.push(encodeURIComponent('source') + '=' + encodeURIComponent('LeaderConnect'));
  formBody = formBody.join('&');

  let headers = new Headers();
  const token = sessionStorage.getItem('access_token');
  headers.append('Authorization', 'Bearer ' + token);
  headers.append('client_id', portalKey);
  const message = getRandomString(25);
  headers.append('X-NW-Message-ID', message);
  headers.append('Content-Type', 'application/x-www-form-urlencoded');
  const response = await fetch(portalApi + 'searchhistoriesactivities', {
    method: 'post',
    headers: headers,
    body: formBody,
  });
  const jsondata = await response.json();
  return jsondata;
};
